export enum SlideFrom {
	LEFT,
	RIGHT,
}
